module.exports = __webpack_public_path__ + "img/FundingPlatform.f759ed5d.svg";